import styled from 'styled-components';
import { themeGet } from 'modules/v2/foundation/theme';
import { Overlay } from '../../styled';
export const StyledOverlay = styled(Overlay) `
  border-radius: ${themeGet('borderRadius.circle')};
`;
